<template>
  <div class="layout layout--authentication">
    <slot />
  </div>
</template>
